import React, { useState, useEffect } from 'react'
import Header from '../../components/common/header/Header'
import "../../assets/css/demo-1.css";
import { Link, useNavigate } from 'react-router-dom';
import Footer from '../../components/common/footer/Footer';
import PhoneInput, { parsePhoneNumber, isValidPhoneNumber } from 'react-phone-number-input';
import 'react-phone-number-input/style.css';
import { isValidEmail, isValidFullName, isValidUsername } from '../../components/validation/Validation';
import { toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css'
import { ToastContainer } from 'react-toastify';
import OtpInput from 'react-otp-input';
import { UserRegister, User_Otp_Verify } from '../../api/auth_api/Auth_Api';
import { get_Page_Seo } from '../../api/global/Global';
import { Helmet } from 'react-helmet';
import { IMG_BASE_URL, WEB_DOMAIN_KEY } from '../../config/Config';

const User_Register = () => {
    const navigate = useNavigate()
    const [pageSeo, set_Page_Seo] = useState({})

    const [isLoading, setIsLoading] = useState(false);
    const [name, setName] = useState("")
    const [user_name, setUser_Name] = useState("")

    const [user_email, setUser_Email] = useState("")
    const [phoneNumber, setPhoneNumber] = useState('+91');
    const [mobileNumber, setMobileNumber] = useState('');
    const [countryCode, setCountryCode] = useState('IN');
    const [isValid, setIsValid] = useState(false);
    const [errorMessage, setErrorMessage] = useState('');

    const [showOtpScreen, setShowOtpScreen] = useState(false);
    const [otp, setOtp] = useState('');
    const [otpError, setOtpError] = useState(false);
    const [otpTimer, setOtpTimer] = useState(5 * 60);
    const [otpExpired, setOtpExpired] = useState(false);
    const [tempId, setTempId] = useState(null);
    const [otpAttempts, setOtpAttempts] = useState(0);
    const [cooldownTime, setCooldownTime] = useState(0);

    const formatTimer = (seconds) => {
        const m = String(Math.floor(seconds / 60)).padStart(2, "0");
        const s = String(seconds % 60).padStart(2, "0");
        return `${m}:${s}`;
    };

    // <-------------- OTP session timeout --------------->
    useEffect(() => {
        if (showOtpScreen) {
            if (otpTimer <= 0) {
                setOtpExpired(true);
                return;
            }
            const countdown = setInterval(() => {
                setOtpTimer(prev => prev - 1);
            }, 1000);
            return () => clearInterval(countdown);
        }
    }, [otpTimer, showOtpScreen]);

    // <-------------- OTP attempts and cooldown initialization & countdown --------------->
    useEffect(() => {
        if (mobileNumber) {
            const savedAttempts = localStorage.getItem(`otp_attempts_${mobileNumber}`);
            if (savedAttempts) {
                setOtpAttempts(parseInt(savedAttempts, 10));
            } else {
                setOtpAttempts(0);
            }

            const cooldownUntil = localStorage.getItem(`otp_cooldown_until_${mobileNumber}`);
            if (cooldownUntil) {
                const remaining = Math.ceil((parseInt(cooldownUntil, 10) - Date.now()) / 1000);
                if (remaining > 0) {
                    setCooldownTime(remaining);
                } else {
                    setCooldownTime(0);
                    localStorage.removeItem(`otp_cooldown_until_${mobileNumber}`);
                    localStorage.removeItem(`otp_attempts_${mobileNumber}`);
                    setOtpAttempts(0);
                }
            } else {
                setCooldownTime(0);
            }
        }
    }, [mobileNumber, showOtpScreen]);

    useEffect(() => {
        if (cooldownTime > 0) {
            const timer = setInterval(() => {
                setCooldownTime(prev => {
                    if (prev <= 1) {
                        clearInterval(timer);
                        localStorage.removeItem(`otp_cooldown_until_${mobileNumber}`);
                        localStorage.removeItem(`otp_attempts_${mobileNumber}`);
                        setOtpAttempts(0);
                        return 0;
                    }
                    return prev - 1;
                });
            }, 1000);
            return () => clearInterval(timer);
        }
    }, [cooldownTime, mobileNumber]);

    const formatMobileNumber = (mobile) => {
        if (!mobile || mobile.length < 10) return mobile;
        const firstTwoDigits = mobile.slice(0, 2);
        const lastTwoDigits = mobile.slice(-2);
        return `${firstTwoDigits}******${lastTwoDigits}`;
    };

    const Handle_User_Register_Otp_Verify = async (e) => {
        e.preventDefault();

        if (mobileNumber) {
            const cooldownKey = `otp_cooldown_until_${mobileNumber}`;
            const cooldownUntil = localStorage.getItem(cooldownKey);
            if (cooldownUntil && Date.now() < parseInt(cooldownUntil, 10)) {
                toast("Too many attempts. please try again later");
                return;
            }
        }

        if (otpExpired) {
            toast("OTP session expired. Please request a new OTP.");
            setShowOtpScreen(false);
            setOtpTimer(5 * 60);
            return;
        }
        setIsLoading(true);

        if (otp.length !== 4) {
            setOtpError(true);
            setIsLoading(false);
            toast("Please enter a valid 4-digit OTP.");
            return;
        }

        const otp_verify_data = {
            otp,
            type: "register",
            country_code: `+${countryCode}`,
            mobile: mobileNumber,
            device_type: "web",
            temp_id: tempId,
        };

        try {
            const response = await User_Otp_Verify(otp_verify_data);
            if (response?.data?.status == "200") {
                setIsLoading(false);
                toast(response?.data?.message);
                if (mobileNumber) {
                    localStorage.removeItem(`otp_attempts_${mobileNumber}`);
                    localStorage.removeItem(`otp_cooldown_until_${mobileNumber}`);
                }
                localStorage.setItem("user_token", response?.data?.data?.token);
                localStorage.setItem("user_is_active", true);
                navigate("/");
            } else {
                setIsLoading(false);
                toast(response?.response?.data?.message || "Invalid OTP");

                if (mobileNumber) {
                    const newAttempts = otpAttempts + 1;
                    setOtpAttempts(newAttempts);
                    localStorage.setItem(`otp_attempts_${mobileNumber}`, newAttempts);

                    if (newAttempts >= 3) {
                        localStorage.setItem(`otp_cooldown_until_${mobileNumber}`, Date.now() + 5 * 60 * 1000);
                        setCooldownTime(300);
                        toast("Too many attempts. please try again later");
                    }
                }
            }
        } catch (error) {
            setIsLoading(false);
            console.error("Error during OTP verification:", error);

            if (mobileNumber) {
                const newAttempts = otpAttempts + 1;
                setOtpAttempts(newAttempts);
                localStorage.setItem(`otp_attempts_${mobileNumber}`, newAttempts);

                if (newAttempts >= 3) {
                    localStorage.setItem(`otp_cooldown_until_${mobileNumber}`, Date.now() + 5 * 60 * 1000);
                    setCooldownTime(300);
                    toast("Too many attempts. please try again later");
                }
            }
        }
    };


    // <--------------get seo meta data----------------->
    useEffect(() => {
        const Get_Page_Seo = async () => {
            setIsLoading(true);
            try {
                const response = await get_Page_Seo()
                console.log("PageSeo:", response);
                if (response?.data?.status == 200) {
                    const seo = response?.data?.data?.seo
                    const filterSeoPage = seo?.find(page => page?.page_name === "User Registration")
                    set_Page_Seo(filterSeoPage)
                }
            } catch (error) {
                console.error(error)
            } finally {
                setIsLoading(false);
            }
        }

        Get_Page_Seo()
    }, [])

    // <----------- Onchnage Events on the Phone Input section's -------------->
    const handlePhoneChange = (value) => {
        if (!value || !value.startsWith('+')) {
            setPhoneNumber('+91'); // Reset to default
            setCountryCode('91');
            setMobileNumber('');
            return;
        }

        setPhoneNumber(value);

        try {
            const parsedPhone = parsePhoneNumber(value);
            setCountryCode(parsedPhone.countryCallingCode); // Update the country code dynamically
            setMobileNumber(parsedPhone.nationalNumber); // Update the local mobile number
        } catch (error) {
            setMobileNumber('');
        }
    };

    // <----------- Handle Key Down Events on the Phone Input section's -------------->
    const handleKeyDown = (e) => {
        // Prevent deleting the "+" or the country code
        if (
            (e.key === "Backspace" || e.key === "Delete") &&
            phoneNumber &&
            phoneNumber.length <= 3 // block when cursor is within "+91"
        ) {
            e.preventDefault();
        }
    };

    const HandleResendOtp = async () => {
        if (mobileNumber) {
            const cooldownKey = `otp_cooldown_until_${mobileNumber}`;
            const cooldownUntil = localStorage.getItem(cooldownKey);
            if (cooldownUntil && Date.now() < parseInt(cooldownUntil, 10)) {
                toast("Too many attempts. please try again later");
                return;
            }
        }
        setIsLoading(true);
        const user_register_data = {
            user_role: 1,
            name: name.trim().replace(/\s{2,}/g, ' '),
            user_name: user_name.trim(),
            email: user_email,
            mobile: mobileNumber,
            country_code: `+${countryCode}`
        };
        try {
            const response = await UserRegister(user_register_data);
            if (response?.data?.status == "200") {
                setIsLoading(false);
                setTempId(response?.data?.data?.user?.id);
                setOtpTimer(5 * 60);
                setOtpExpired(false);
                setOtp('');
                toast("OTP resent successfully");
            } else {
                setIsLoading(false);
                toast(response?.response?.data?.message || "Error resending OTP");
            }
        } catch (error) {
            setIsLoading(false);
            console.log("error", error);
        }
    };

    // <--------- Handle the User Register function's ------------------->
    const HandleUserRegister = async (e) => {
        e.preventDefault()
        if (mobileNumber) {
            const cooldownKey = `otp_cooldown_until_${mobileNumber}`;
            const cooldownUntil = localStorage.getItem(cooldownKey);
            if (cooldownUntil && Date.now() < parseInt(cooldownUntil, 10)) {
                toast("Too many attempts. please try again later");
                return;
            }
        }
        setIsLoading(true)

        const trimmedName = name.trim().replace(/\s{2,}/g, ' ');
        const trimmedUsername = user_name.trim();

        if (!trimmedName || !isValidFullName(trimmedName)) {
            toast("Please enter a valid Full Name (letters and spaces only, 2-50 characters).");
            setIsLoading(false)
            return;
        }

        if (!trimmedUsername || !isValidUsername(trimmedUsername)) {
            toast("Please enter a valid Username (start with a letter, 3-20 characters, letters/numbers/._ only).");
            setIsLoading(false)
            return;
        }

        const user_register_data = {
            user_role: 1,
            name: trimmedName,
            user_name: trimmedUsername,
            email: user_email,
            mobile: mobileNumber,
            country_code: `+${countryCode}`
        }
        console.log("user_register_data", user_register_data)

        if (!user_email || !isValidEmail(user_email)) {
            toast("Please enter a valid email address.");
            setIsLoading(false)
            return;
        }

        if (!isValid) {
            toast("Please enter a valid phone number containing only numbers.");
            setIsLoading(false)
            return;
        }
        console.log("object", { user_name, user_email, mobileNumber, countryCode })
        try {
            const response = await UserRegister(user_register_data)
            if (response?.data?.status == "200") {
                setIsLoading(false)
                setTempId(response?.data?.data?.user?.id);
                setShowOtpScreen(true);
                setOtpTimer(5 * 60);
                setOtpExpired(false);
                setOtp('');
            }
            else if (response?.response?.data?.status == "500") {
                setIsLoading(false)
                toast(response?.response?.data?.message)
            }
            console.log("response", response?.response?.data)
        } catch (error) {
            console.log("error", error)
            setIsLoading(false)
        }
    }

    const handleChange = (e) => {
        const { name, value } = e.target;
        if (name === "email") {
            setUser_Email(value)

        }

    };
    // <-------- Apply for the Phone Number Validtion According to the Country and Country code here ----------->
    useEffect(() => {
        setIsValid(isValidPhoneNumber(phoneNumber));
    }, [phoneNumber]);

    return (
        <>
            <Helmet>
                <title>{pageSeo?.meta_title}</title>
                <meta name="description" content={pageSeo?.meta_description} />
                <link rel="canonical" href={`${WEB_DOMAIN_KEY}user-register`} />
                <link rel="alternate" hreflang="en-us" href={`${WEB_DOMAIN_KEY}user-register`} />

            </Helmet>
            <div>
                <Header />
                <section className='banner-section'>
                    <div className={`${pageSeo?.image ? "block" : "hidden"} relative`}>
                        <img src={`${IMG_BASE_URL}${pageSeo?.image}`} alt={pageSeo?.alt
                        } className='w-full h-[200px] md:h-[300px] lg:h-[400px] object-cover' />


                    </div>
                </section>
                <section className="gi-register bg-[#F0F4F8] py-[40px] max-[767px]:py-[30px] min-h-screen w-full">

                    <div className="flex items-center justify-center min-h-screen font-poppins">
                        <div className="bg-white p-6 rounded-lg overflow-hidden shadow-xl sm:max-w-lg sm:w-full">

                            {/* <!-- Registration Form Body --> */}
                            {
                                isLoading ? (
                                    <div className="fixed inset-0 bg-black bg-opacity-50 flex justify-center items-center z-50">
                                        <div className="w-16 h-16 border-t-4 border-white border-solid rounded-full animate-spin"></div>
                                    </div>
                                ) : (

                                    <div className="text-left my-2">
                                        <div className="gi-login-box w-[100%] px-[15px] max-[991px]:w-full max-[991px]:p-[0]" id="login_modal">
                                            {!showOtpScreen ? (
                                                <>
                                                    <div className="section-title-2 w-full mb-[20px] pb-[20px]">
                                                        <h2 className="gi-title mb-[0] font-manrope text-[26px] font-semibold text-[#4b5966] relative inline p-[0] capitalize leading-[1]">
                                                            New Registration
                                                        </h2>
                                                        <p className="max-w-[400px] mt-[15px] text-[14px] text-[#777] leading-[23px]">Create New Account</p>
                                                    </div>
                                                    <div className="gi-login-wrapper my-[0] mx-auto">
                                                        <div className="gi-login-container">
                                                            <div className="gi-login-form">
                                                                <form action="#" method="post" className="flex flex-col" onSubmit={HandleUserRegister}>

                                                                    <div className="gi-login-wrap flex flex-col">
                                                                        <label className="mb-[10px] text-[#4b5966] text-[15px] font-medium tracking-[0] leading-[1]">
                                                                            Full Name
                                                                        </label>
                                                                        <div className="iconflex">
                                                                            <i className="fi-rr-user text-[#303030] text-[18px] leading-[17px]"></i>
                                                                            <input type="text" name="name" value={name} onChange={(e) => setName(e.target.value)} placeholder="Enter your name"
                                                                                className="w-full mb-[15px] px-[15px] bg-transparent border-[1px] border-solid border-[#eee] rounded-[5px] text-[#777] text-[14px] outline-[0] h-[50px]"
                                                                                required />
                                                                        </div>
                                                                    </div>
                                                                    <div className="gi-login-wrap flex flex-col">
                                                                        <label className="mb-[10px] text-[#4b5966] text-[15px] font-medium tracking-[0] leading-[1]">
                                                                            User Name
                                                                        </label>
                                                                        <div className="iconflex">
                                                                            <i className="fi-rr-user text-[#303030] text-[18px] leading-[17px]"></i>
                                                                            <input type="text" name="user_name" value={user_name} onChange={(e) => setUser_Name(e.target.value)} placeholder="Enter your name"
                                                                                className="w-full mb-[15px] px-[15px] bg-transparent border-[1px] border-solid border-[#eee] rounded-[5px] text-[#777] text-[14px] outline-[0] h-[50px]"
                                                                                required />
                                                                        </div>
                                                                    </div>
                                                                    <div className="gi-login-wrap flex flex-col">
                                                                        <label className="mb-[10px] text-[#4b5966] text-[15px] font-medium tracking-[0] leading-[1]">
                                                                            Email ID
                                                                        </label>
                                                                        <div className="iconflex">
                                                                            <i className="fi-rs-envelope text-[#303030] text-[18px] leading-[17px]"></i>
                                                                            <input type="email" value={user_email} onChange={handleChange} name="email" placeholder="Email ID"
                                                                                className="w-full mb-[15px] px-[15px] bg-transparent border-[1px] border-solid border-[#eee] rounded-[5px] text-[#777] text-[14px] outline-[0] h-[50px]"
                                                                                required />
                                                                        </div>
                                                                    </div>
                                                                    <div className="gi-login-wrap flex flex-col mb-3">
                                                                        <label className="mb-[10px] text-[#4b5966] text-[15px] font-medium tracking-[0] leading-[1]">
                                                                            Phone Number
                                                                        </label>
                                                                        <PhoneInput
                                                                            international
                                                                            value={phoneNumber}
                                                                            defaultCountry={countryCode}
                                                                            onChange={handlePhoneChange}
                                                                            onKeyDown={handleKeyDown}
                                                                            maxLength={15}
                                                                            className="w-full mb-[15px] px-[15px] bg-transparent border-[1px] border-solid border-[#eee] rounded-[5px] text-[#777] text-[14px] outline-[0] h-[50px]"
                                                                            placeholder="Enter phone number"
                                                                        />
                                                                        {!isValid && <span className="text-red-500 text-sm">Please enter a valid phone number</span>}
                                                                    </div>
                                                                    <div className="flex justify-between">
                                                                        <div className="flex items-start">
                                                                            <div className="flex items-center h-5">
                                                                                <input id="remember" aria-describedby="remember" type="checkbox"
                                                                                    className="bg-gray-50 border border-gray-300 focus:ring-3 focus:ring-blue-300 h-4 w-4 rounded dark:bg-gray-600 dark:border-gray-500 dark:focus:ring-blue-600 dark:ring-offset-gray-800"
                                                                                    required />
                                                                            </div>
                                                                            <div className="text-sm ml-3">
                                                                                <label for="remember" className="text-gray-900 dark:text-gray-500">
                                                                                    I agree to Terms & Conditions and Privacy Policy
                                                                                </label>
                                                                            </div>
                                                                        </div>
                                                                    </div>
                                                                    <div className="gi-login-wrap">
                                                                        <button type="submit"
                                                                            className="w-full mt-[20px] block p-[14px] text-center text-[#fff] bg-gradient-to-r from-[#9F2225] to-[#FFB500] rounded-[5px] text-[#777] text-[16px] outline-[0] h-[50px]">
                                                                            Register
                                                                        </button>
                                                                    </div>

                                                                    <span className="gi-login-wrap gi-login-btn mt-[20px] flex flex-row justify-center gap-3 items-center">
                                                                        <span className="text-[#777] text-[14px]">
                                                                            Already have an account?
                                                                        </span>
                                                                        <Link to="/user-login"
                                                                            className="gi-btn-1 btn py-[8px] px-[15px] text-[#9F2225] border-[0] transition-all duration-[0.3s] ease-in-out overflow-hidden text-center text-[14px] font-semibold relative rounded-[5px] hover:text-[#333]">
                                                                            Login
                                                                        </Link>
                                                                    </span>

                                                                </form>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </>
                                            ) : (
                                                <>
                                                    <div className="section-title-2 w-full mb-[20px] pb-[20px] text-center">
                                                        <h2 className="gi-title mb-[0] font-Poppins text-[26px] font-semibold text-[#4b5966] relative inline p-[0] capitalize leading-[1]">
                                                            Verification code
                                                        </h2>
                                                        <p className="mt-[15px] text-[14px] text-[#777] leading-[23px]">
                                                            We have sent the verification code on your mobile number +
                                                            <span className="font-bold text-black">{formatMobileNumber(mobileNumber)}</span>
                                                        </p>
                                                    </div>
                                                    <div className="gi-login-wrapper my-[0] mx-auto text-center">
                                                        <div className="gi-login-container">
                                                            <div className="gi-login-form">
                                                                <form method="post" className="flex flex-col" onSubmit={Handle_User_Register_Otp_Verify}>
                                                                    <div className="gi-login-wrap flex-col">
                                                                        {/* OTP Input Fields */}
                                                                        <div className="otp-input-fields w-full flex justify-center gap-[10px] mb-[20px]">
                                                                            <OtpInput
                                                                                value={otp}
                                                                                onChange={(newOtp) => {
                                                                                    if (/^\d*$/.test(newOtp)) {
                                                                                        setOtp(newOtp);
                                                                                        if (newOtp.length === 4) {
                                                                                            setOtpError(false);
                                                                                        }
                                                                                    }
                                                                                }}
                                                                                numInputs={4}
                                                                                shouldAutoFocus
                                                                                renderInput={(props) => (
                                                                                    <input
                                                                                        {...props}
                                                                                        type="number"
                                                                                        className="otp__digit otp__field__1 rounded-[50%] border-[1px] border-[#ddd] p-[0] text-center text-[16px] text-[#333] focus:outline-none"
                                                                                        style={{ width: "40px", height: "40px" }}
                                                                                    />
                                                                                )}
                                                                            />
                                                                        </div>
                                                                        {otpError && (
                                                                            <span className="text-red-500 text-sm">
                                                                                Please enter a valid OTP.
                                                                            </span>
                                                                        )}
                                                                    </div>
                                                                    <div className="text-center mb-[15px]">
                                                                        {cooldownTime > 0 ? (
                                                                            <span className="text-[14px] text-red-500 font-medium">
                                                                                Too many attempts. Try again in {formatTimer(cooldownTime)}
                                                                            </span>
                                                                        ) : (
                                                                            <span className="text-[14px] text-[#777]">
                                                                                {otpTimer > 0 ? `Resend OTP in ${formatTimer(otpTimer)}` : ""}
                                                                            </span>
                                                                        )}
                                                                    </div>
                                                                    <button
                                                                        type="button"
                                                                        onClick={HandleResendOtp}
                                                                        disabled={otpTimer > 0 || cooldownTime > 0}
                                                                        className={`w-full mb-[10px] block p-[14px] text-center rounded-[5px] text-[16px] outline-[0] h-[50px] ${otpTimer > 0 || cooldownTime > 0
                                                                            ? "bg-gray-300 text-gray-500 cursor-not-allowed"
                                                                            : "text-[#fff] bg-gradient-to-r from-[#9F2225] to-[#FFB500]"
                                                                            }`}
                                                                    >
                                                                        Resend OTP
                                                                    </button>
                                                                    <button
                                                                        type="submit"
                                                                        disabled={cooldownTime > 0}
                                                                        className={`w-full mt-[20px] block p-[14px] text-center text-[#fff] rounded-[5px] text-[16px] outline-[0] h-[50px] ${cooldownTime > 0
                                                                            ? "bg-gray-300 text-gray-500 cursor-not-allowed"
                                                                            : "bg-gradient-to-r from-[#9F2225] to-[#FFB500]"
                                                                            }`}
                                                                    >
                                                                        Submit
                                                                    </button>
                                                                </form>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </>
                                            )}
                                        </div>
                                    </div>
                                )
                            }
                        </div>
                    </div>

                </section>

                {/* <--------- Footer section's -------------> */}
                <Footer />
            </div>
        </>
    )
}

export default User_Register